/* eslint-disable jsx-a11y/anchor-is-valid */
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@redux/store';
import { Button } from "@fc/devteam-components-library";
import Avatar from '@components/profile/avatar';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import useOutsideClick from '@customHooks/use-outside-click';
import { OrganizationCalendarI } from '@interfaces/organizationI';
import { setOrganization } from '@redux/slices/practitioner/practitioner-organization';
// import { getPractitionersInformation } from '@services/organization-structure';
import { logOut, setAuth, setSessionSegments, setSubscriptionType } from '@redux/slices/session-slice';
import { getPractitionerProfileData, readPractitionerProfile } from '@services/signup';
import { setPractitionerProfile, setProfile } from '@redux/slices/practitioner/practitioner-profile';
import { logout } from '@functions/chat-controller/chatController';
import { cleanAppointment } from '@redux/slices/appoinments/appointments.slice';
import { setLogged } from '@redux/slices/socketChat/loggedValidation';
import { cleanCalendarHeaderState } from '@redux/slices/calendar/header/calendar-header.slice';
import { setChatSocketState } from '@redux/slices/socketChat/storeForRender/chatSocketState';
import { setChatNewMessageFlagClean } from '@redux/slices/socketChat/chatMessageArrive-slice';
import LogOutButton from '@components/log-out/log-out-button';
import { getPermissions } from '@services/fc-user/permissions';
import { setPermissions } from '@redux/slices/practitioner/practitioner-permissions';
import { mergeUserRolesGlobal } from '@functions/permissions/permissionsFunctions';
import { checkOrganizationSubscription } from '@services/finance/finance-services';
import { notify } from '@functions/notification';
import { getSubdomainCodeEmail } from '@functions/getSubDomainSalud';
import { SubscriptionTypeI } from '@interfaces/finance/general';
import { cleanOrderData } from '@redux/slices/appoinments/document-device-order.slice';
import { IPermission, PermissionLevel } from '@interfaces/fc-user/permissions';
import useUserInitialQuiz from '@customHooks/initial-quiz/use-user-initial-quiz';
import usePractitionerIsActive from '@customHooks/usePractitionerIsActive';
import usePractitionerOrganizations from '@customHooks/organization/use-practitioner-organizations';
import { createPractitionerOrganization } from '@services/services/servies';
import OrganizationListItem from './organization-list-item';
import useOriginSegments from '@customHooks/catalogs/use-origin-segments';

const DEFAULT_PERMISSIONS: IPermission[] = [
    {
        "level": PermissionLevel.NONE,
        "permission": "calendar"
    },
    {
        "level": PermissionLevel.NONE,
        "permission": "patients"
    },
    {
        "level": PermissionLevel.NONE,
        "permission": "newPatient"
    },
    {
        "level": PermissionLevel.NONE,
        "permission": "newDiagnosis"
    },
    {
        "level": PermissionLevel.NONE,
        "permission": "scheduleAppointment"
    },
    {
        "level": PermissionLevel.NONE,
        "permission": "editAppointment"
    },
    {
        "level": PermissionLevel.NONE,
        "permission": "viewFile"
    },
    {
        "level": PermissionLevel.NONE,
        "permission": "recordDetails"
    },
    {
        "level": PermissionLevel.NONE,
        "permission": "newAppointment"
    },
    {
        "level": PermissionLevel.NONE,
        "permission": "newRecord"
    },
    {
        "level": PermissionLevel.NONE,
        "permission": "documents"
    },
    {
        "level": PermissionLevel.NONE,
        "permission": "studies"
    },
    {
        "level": PermissionLevel.WRITE,
        "permission": "publicProfile"
    },
    {
        "level": PermissionLevel.WRITE,
        "permission": "services"
    },
    {
        "level": PermissionLevel.NONE,
        "permission": "addService"
    },
    {
        "level": PermissionLevel.WRITE,
        "permission": "addOffice"
    },
    {
        "level": PermissionLevel.NONE,
        "permission": "addSchedule"
    },
    {
        "level": PermissionLevel.WRITE,
        "permission": "account"
    },
    {
        "level": PermissionLevel.NONE,
        "permission": "devices"
    },
    {
        "level": PermissionLevel.NONE,
        "permission": "chat"
    },
    {
        "level": PermissionLevel.NONE,
        "permission": "quiz"
    },
    {
        "level": PermissionLevel.NONE,
        "permission": "blog"
    },
    {
        "level": PermissionLevel.NONE,
        "permission": "org"
    },
    {
        "level": PermissionLevel.NONE,
        "permission": "reports"
    },
    {
        "level": PermissionLevel.NONE,
        "permission": "personalInfo"
    }
]

const SessionData = () => {
    const { t } = useTranslation(['sessionCard', 'organization'])
    // redux selector session slice
    // TODO: Replace `organizationsList` Redux implementation for hook
    const {session, organizationsList: organizationsRelated, organization: organizationRedux} = useSelector((state: RootState) => ({session: state.session, organizationsList: state.relatedOrganization, organization: state.organizations}));
    const [openCard, setOpenCard] = useState(false);
    const dispatch = useDispatch();
    const history = useNavigate();
    const ref = useRef() as React.MutableRefObject<HTMLDivElement>;
    // const [organizationsInfo, setOrganizationsInfo] = useState<OrganizationInfo[]>([]);
    const [organizationsInfo, setOrganizationsInfo] = useState<OrganizationCalendarI[]>([]);
    const [accessPrivateProfile, setAccessPrivateProfile] = useState<boolean>(true);
    const [notOrganization, setNotOrganization] = useState<boolean>(false);
    const { data: userInitialQuiz, isLoading } = useUserInitialQuiz(true)
    const [freeTrial, setFreeTrial] = useState(false)
    const { isActive } = usePractitionerIsActive()
    // TODO: Replace Redux implementation for this hook
    const { organizations: orAll } = usePractitionerOrganizations()
    const { segments, loading: loadingSegments} = useOriginSegments()
    const creatingPracticeRef = useRef(false)


    const createOrganization = async (username: string,) => {
        try {
            const org = await  createPractitionerOrganization(username)
            return org
        } catch (error) {
            console.debug("error create org: ",error)
            return undefined
        }
    }
    const changePrivatePractice = async () => {
        if(!session.username || creatingPracticeRef.current) return

        // If the user already owns a private practice, switch to it instead of creating a new one
        const ownPractice = orAll?.find(org => org.predeterminedDrProx)
        if(ownPractice){
            clickOrganization(ownPractice)
            return
        }

        creatingPracticeRef.current = true
        try {
            const org = await createOrganization(session.username)
            if(org){
                history('/login')
            }
        } finally {
            creatingPracticeRef.current = false
        }
    }
    const getPermissionsByUser = async (username: string, organizationId: number) => {
        try {
            const permissions = await getPermissions(username,organizationId, ['drProx'])
            if(permissions.drProx){
                return permissions.drProx
            }else{
                return undefined
            }
        } catch (error) {
            console.error("getPermissionsByUser error:",error)
            return undefined
        }
    }

    /**
     * @abstract Check if the organization has active subscription (If we're in a subdomain skip valdiation)
     * @param organizationSelected the organization we want to switch
     * @returns Organization with paid subscription
     */
    const checkPaid = async (organizationSelected: OrganizationCalendarI) => {
        //If we're not in DrProx Core then skip subscription and always is paid
        const subdomainCode = getSubdomainCodeEmail(false)
        if(subdomainCode !== "DRPROX" || organizationSelected.organizationType === null){
            return organizationSelected
        }
        const isPaid = await checkOrganizationSubscription(organizationSelected.organizationId)
        dispatch(setSubscriptionType(isPaid))
        if(isPaid){
            if(isPaid.type === "CUP"){
                setFreeTrial(true)
            }
            return organizationSelected
        } 
            
        notify({message: `La organización ${organizationSelected.organizationName} no ha pagado, y por lo tanto no puedes acceder a ella`, messageType: "error"})
        const organizationResults = organizationsRelated.organizationsM.map(async org => {
            const isSubscribedOrg = await checkOrganizationSubscription(org.organizationId)
            return{
                organization: org,
                isSubscribed: isSubscribedOrg
            }
        })
        const result: {organization: OrganizationCalendarI, isSubscribed: SubscriptionTypeI}[] = await Promise.all(organizationResults)
        const isOrgPaid = result.find(eachOrg => eachOrg.isSubscribed.type !== "NOT_PAID")
        if(isOrgPaid){
            return isOrgPaid.organization
        }
        return organizationSelected
    }

    /**
     * Switch user organization for application use. Update redux
     * @param organizationToSwitch 
     */
    const switchToOrganization = async (organizationToSwitch: OrganizationCalendarI) => {
        if(organizationToSwitch.organizationId === organizationRedux.organizationId){
            console.debug("switchToOrganization cancel get data")
            return
        }
        const organization = await checkPaid(organizationToSwitch)
        checkOwner(organization)
        // if(organization.organizationInfo.roles.some(role => role === "HP"))
        // {
        //     await updateInitialQuizInfo()
        //     // setInitialQuiz(session.username ?? '')
        // }
        if(organization) {
            try {            
                // dispatch(setAuth({...session, orgRoles: organization.organizationInfo?.roles}));
                // const profile = await readPractitionerProfile(String(organization.organizationInfo.usernameSA));
                const profile = await readPractitionerProfile(String(session.username ?? ""))
                dispatch(setProfile(profile));
                try
                {
                    const newProfile = await getPractitionerProfileData(session.username ?? "")
                    if(newProfile)
                    {
                        if(profile && !newProfile.email)
                        {
                            newProfile.email = profile.email
                        }
                    }
                    dispatch(setPractitionerProfile(newProfile))
                }
                catch(err)
                {
                    console.warn(`Could not retrieve new profile info for ${session.username}`, err)
                }
            } 
            catch(error) 
            {
                console.error("switchToOrganization", error);
            }
            const permissionByUserAndOrganization = await getPermissionsByUser(session.email ?? '', organization.organizationId)
            if(permissionByUserAndOrganization){
                dispatch(
                    setPermissions(permissionByUserAndOrganization)
                );
            }else{
                if(organization.roles){
                    const permissionDefaultDrProx = await mergeUserRolesGlobal(organization.roles, 'drProx')
                    dispatch(setPermissions(permissionDefaultDrProx))
                }
            }
            dispatch(setOrganization(organization));
        }
        // verifyFreeTrial()
        sortOrganizations(organization)
    }
    const switchToPrivatePractice = async() => {
        const permissionDefaultDrProx = await mergeUserRolesGlobal(['OSA'], 'drProx')
        dispatch(setPermissions(permissionDefaultDrProx))
        if(!permissionDefaultDrProx)
            dispatch(setPermissions(DEFAULT_PERMISSIONS))

        setAccessPrivateProfile(true)
        dispatch(setAuth({...session, orgRoles: ['OSA']}));
        dispatch(setOrganization({
            organizationId: 0,
            organizationName: '',
            organizationType: null,
            predetermined: false,
            predeterminedDrProx: false
        }));
    }
    const sortOrganizations =  (organization: OrganizationCalendarI) => {
        if(organizationsInfo.length > 1){
            const serviceIndex = organizationsInfo.indexOf(organization);
            const serviceItem = organizationsInfo.splice(serviceIndex, 1)[0];
            organizationsInfo.splice(0, 0, serviceItem)
            setOrganizationsInfo(organizationsInfo)
        }
    }

    const getOrganizationsRoles = useCallback(async () => {
        if(!orAll) return
        const organizationsFiltred = orAll.reduce((orgs: OrganizationCalendarI[], currentOrg: OrganizationCalendarI) => {
            if(orgs.some((org) => org.organizationId === currentOrg.organizationId)) {
                return orgs
            } else {
                return [...orgs, currentOrg]
            }
        }, []);
        
        // const organizationsInfoData = organizationsFiltred.map(async(org) => {
        //     const organization = await getPractitionersInformation(String(session.email), org.organizationId, Intl.DateTimeFormat().resolvedOptions().timeZone);

        //     return {
        //         ...org,
        //         organizationInfo: {
        //             ...organization
        //         }
        //     }
        // });

        // const organizationResult = await Promise.all(organizationsInfoData);
        setOrganizationsInfo(organizationsFiltred);

        if(organizationRedux.organizationId === 0){
            const organizationDefautl = organizationsFiltred.find((org) => org.predeterminedDrProx);
            if(organizationDefautl) {
                switchToOrganization(organizationDefautl);
            } else {
                if(organizationsFiltred.length){
                    switchToOrganization(organizationsFiltred[0]);
                }else{
                    setNotOrganization(true)
                    switchToPrivatePractice()
                }
            }
        }else{
            const organizationFound = organizationsFiltred.find(org => org.organizationId === organizationRedux.organizationId)
            if(organizationFound)
                switchToOrganization(organizationFound)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [orAll, session.email, organizationRedux]);

    useOutsideClick(ref, () => {
        if (openCard) setOpenCard(false);
    });

    /**
     * Check if currently logged user is the owner of the organization. 
     * The result will update the `notOrganization` value state.
     * @param organization Organization to check
     */
    const checkOwner = (organization: OrganizationCalendarI) => {
        // `orAll` is fetched on load; the legacy `relatedOrganization.organizations` list is not populated on login
        const owner = organization.organizationId === 0
            || organization.predeterminedDrProx
            || (!!organization.usernameSA && organization.usernameSA === session.username)
        setAccessPrivateProfile(owner)
        const exist = orAll?.some(org => org.predeterminedDrProx)
        setNotOrganization(!exist)
        // return owner
    }
    // const checkUserRole = (organization: OrganizationInfo) => {
    //     console.log("is osa> ",organization.organizationInfo.roles.some((role) => role === 'OSA'))
    //     organization.organizationInfo.roles.some((role) => role === 'OSA') ? setAccessPrivateProfile(true) : setAccessPrivateProfile(false)
    // }

    /**
     * Function to check if the current subscription is a free trial
     */
    const verifyFreeTrial = async () => {
        if(session.subscriptionType) return
        const freeTrial = await checkOrganizationSubscription(organizationRedux.organizationId)
        dispatch(setSubscriptionType(freeTrial))
        if(freeTrial.type === "CUP"){
            setFreeTrial(true)
        }
    }

    const cleanChatSlices = () => 
    {
        dispatch(setChatSocketState([]));
        dispatch(setChatNewMessageFlagClean())
        dispatch(logOut());
    }
    useEffect(() => {
        const getToken = sessionStorage.getItem('auth-token')
        verifyFreeTrial()
        if(!getToken){
            dispatch(logOut());
            logout({})
            cleanChatSlices()
            // finishCommunication();
            dispatch(cleanAppointment());
            dispatch(setLogged(false));
            dispatch(setOrganization({
                organizationId: 0,
                organizationName: '',
                organizationType: null,
                predetermined: false,
                predeterminedDrProx: false
            }));
            dispatch(cleanCalendarHeaderState());
            dispatch(cleanOrderData())
            history("/")
        }
        // eslint-disable-next-line 
    }, []);

    useEffect(() => {
        getOrganizationsRoles();
    }, [getOrganizationsRoles]);

    const dispatchSegments = useCallback(() => {
        if(loadingSegments === false && segments !== null ){
            dispatch(setSessionSegments(segments))
        }
    }, [dispatch, loadingSegments, segments])

    useEffect(() => {
        dispatchSegments()
    }, [dispatchSegments, loadingSegments, segments ]);

    useEffect(() => {
        if(isActive || isActive === null || isLoading) return
        if(userInitialQuiz?.pmdPractitionerDTO.finalized === true && userInitialQuiz.pmdPractitionerDTO.practitionerStatus === "VALIDATED")
        {
            // history({
            //     pathname: '/sign-up/success',
            //     search: `?step=${window.btoa('personal-data')}`,
            // });
            return
        }
        else
        {
            history("/initial-quiz");
        }
    }, [isActive, userInitialQuiz, isLoading, history])

    const clickOrganization = (org: OrganizationCalendarI) => {
        switchToOrganization(org); 
        setOpenCard(false); 
        history("/practitioner/services");
    }

    return (
        <div className="HeaderUser" ref={ref}>
            <div className="HeaderUser" onClick={() => setOpenCard(!openCard)}>
                <div className="HeaderUser__Avatar">
                    <Avatar roleCode={'PR'} username={session.username?? ''} size={32} />
                </div>
                <div className='VerticalFlex'>
                    <p className="Body1">{session.username}</p>
                    {freeTrial && 
                        <p className='HeaderUser__Freetrial'>
                            Versión gratuita
                        </p>
                    }
                </div>
                <div className="HeaderUser__Arrow">
                    <em className={openCard ? "fas fa-caret-up" : "fas fa-caret-down"} />
                </div>
            </div>
            {openCard ?
            <div className="HeaderUser__Card" style={{height: 'auto', minHeight: '248px'}}>
                <div className="HeaderUser__Avatar">
                    <Avatar roleCode={'PR'} username={session.username?? ''} size={120} />
                </div>
                <div className="HeaderUser__Info">
                    <span className="HeaderUser__Text">{session.username}</span>
                    {accessPrivateProfile &&
                        <a className="HeaderUser__Link" onClick={() => {history('/practitioner/profile'); setOpenCard(false)}}>{t('goToProfile')}</a>
                    }
                </div>
                <span className='Divider'/>
                { (organizationRedux.organizationId === 0 && notOrganization && !organizationsInfo.length ) &&
                        <p className="HeaderUser__Text" style={{ display: 'flex', gap: '4px', justifyContent: 'center', alignItems: 'center'}}>
                            No hay organizaciones relacionadas
                        </p>
                }
                { (organizationRedux.organizationId !== 0 && notOrganization) &&
                        <Button
                            buttontext={t('Ir a mi practica privada')}
                            buttontype="button"
                            action={changePrivatePractice}
                        ></Button>
                }
                {organizationsInfo.map((org) =>
                    <OrganizationListItem
                        key={ org.organizationId }
                        org={ org }
                        onClick={ clickOrganization } />
                )}
                <LogOutButton
                    isHeader = {true}
                />
            </div>
            : null
            }
        </div>
    );
};
export default SessionData;
